<div class="full-view flex-centered boxWrapper">
  <img class="cloud normal" src="./assets/img/wolke_4.png" alt="" />
  <img class="cloud flipped" src="./assets/img/wolke_4.png" alt="" />

  <div class="centered-box">
    <h2>Wir sind kurz offline</h2>
    <p></p>
    <p></p>
    <div class="text">
      <h3>Unsere Website wird aktuell gewartet. Die Arbeiten laufen von <b>Mittwoch, 14.01. bis Montag, 19.01.</b></h3>
      <p></p>
      <h3>Ab <b>Dienstag, 20.01.,</b> kannst du dich wieder <b>ganz normal registrieren.</b></h3>
      <p></p>
      <h3>Danke für deine Geduld – wir freuen uns auf dich!</h3>
    </div>
    <img class="logo" alt="Logos der Markant Start-up Arena" src="./assets/svg/Voila_Logo_RGB_2022_positiv.svg" />
  </div>
</div>
